<template>
  <section class="mt-12" v-if="allFacilities.length">
    <h4 class="fs-20 font-medium mb-4">
      Amenities
    </h4>

    <template>
      <h5 class="mt-6 mb-4 font-medium">
        {{ searchType === 'resort' ? 'Resort' : 'Vessel' }}
      </h5>

      <checkbox v-for="item in resortFacilities"
        :key="item.slug"
        v-model="options.facilitiesOptions[`opt${item.slug}`]"
        @change="$emit('filter-changed')">
        {{ item.name }}
      </checkbox>
    </template>

    <template>
      <h5 class="mt-6 mb-4 font-medium">
        Diving
      </h5>

      <checkbox v-for="item in diveCenterFacilities"
        :key="item.slug"
        v-model="options.facilitiesOptions[`opt${item.slug}`]"
        @change="$emit('filter-changed')">
        {{ item.name }}
      </checkbox>
    </template>
  </section>
</template>

<script>
import flatMap from 'lodash/flatMap'
import uniqBy from 'lodash/uniqBy'
import orderBy from 'lodash/orderBy'
import get from 'lodash/get'
import { mapState } from 'vuex'

import Checkbox from '../../core/Checkbox'
import {
  RESORT_FACILITIES,
  LIVEABOARD_FACILITIES,
  DIVE_CENTER_FACILITIES
} from '../../../helpers/constants'

export default {
  components: {
    Checkbox
  },
  data () {
    return {
      searchType: window.zubluSearchType
    }
  },
  inject: ['options'],
  computed: {
    ...mapState(['resortsResult']),
    allFacilities () {
      let allFacilities = flatMap(this.resortsResult, resort => {
        return get(resort, ['inclusions_objects'], [])
      })
      allFacilities = uniqBy(allFacilities, item => item.name)

      return orderBy(allFacilities, ['order', 'name'], ['asc', 'asc'])
    },
    resortFacilities () {
      if (window.zubluSearchType === 'resort') {
        return this.allFacilities.filter(item => item.list_id === RESORT_FACILITIES)
      }
      else if (window.zubluSearchType === 'liveaboard') {
        return this.allFacilities.filter(item => item.list_id === LIVEABOARD_FACILITIES)
      }

      return []
    },
    diveCenterFacilities () {
      return this.allFacilities.filter(item => item.list_id === DIVE_CENTER_FACILITIES)
    }
  }
}
</script>